import { c as _c } from "react/compiler-runtime";
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { Switch } from '@src/components/chakra-ui/switch';
import React, { useEffect, useState } from 'react';
type ToggleInputProps = {
  defaultValue?: boolean;
  uncheckedValue?: string;
  icon?: any;
  onChange: (value) => any;
  placeholder?: string;
  label?: string;
};
export const ToggleInput = props => {
  const $ = _c(16);
  const [value, setValue] = useState(props.defaultValue);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e_0 => {
      setValue(e_0.target.checked);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleChange = t0;
  let t1;
  if ($[1] !== props || $[2] !== value) {
    t1 = () => {
      props.onChange(value);
    };
    $[1] = props;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== value) {
    t2 = [value];
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== props.label) {
    t3 = props.label && <Text flexGrow={1} marginBottom="0.5em" opacity={0.5} textStyle="label2xs">{props.label}</Text>;
    $[6] = props.label;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== value) {
    t4 = <Switch checked={value} onChange={handleChange} />;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <HStack align="center">{t3}{t4}</HStack>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button display="none" type="submit" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5) {
    t7 = <Box width="full">{t5}{t6}</Box>;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};